function lucceDiamondGradingSummary(params, suffix) {
  const isRound = /^round(?:\s+cut)?$/i.test(String(shape || '').trim());
  return [['cut_precision', 'Cut'], ['polish', 'Polish'], ['symmetry', 'Symmetry']].filter(function (field) {
    return field[0] !== 'cut_precision' || isRound;
  }).map(function (field) {
    const value = (params.get(field[0] + suffix) || '').trim();
    return value && value !== 'null' && value !== 'undefined' && value !== 'U' ? ', ' + value : '';
  }).join('');
}

function lucceFluorescenceSummary(code) {
  const labels = { N: 'None', F: 'Faint', VSL: 'Very Slight', M: 'Medium', SL: 'Slight', NONE: 'None', FAINT: 'Faint', 'VERY SLIGHT': 'Very Slight', MEDIUM: 'Medium', SLIGHT: 'Slight' };
  const value = labels[String(code || '').trim().toUpperCase()];
  return value ? ', ' + value : '';
}


let web_server = 'https://api.luccerings.com'
let shapes = ['ROUND', 'OVAL','EMERALD','PEAR','CUSHION','ROSE','ASSCHER','RADIANT','MARQUISE','PRINCESS','ANTIQUE','HEART','TRILLIANT']
let price

let product_form = document.getElementById('Customize-Product-Form')
let selection_wrapper = document.getElementById('Customize-Selection-Wrapper')
let engravings_wrapper = document.getElementById('Customize-Engravings-Wrapper')

let engravings_ele = document.getElementById('Customize-Diamond-Engravings')

let make_selection_btn = document.getElementById('Customize-Make-Selection')
let ring_name = document.getElementById('Customize-Product-Title').innerText
let is_necklace = /necklace|bracelet|earring|lifestyle/i.test(ring_name)
let ring_handle = document.getElementById('Customize-Product-Handle').innerText
let shape = getShape()
let ring_shape = capitalizeFirstLetter(shape.toLowerCase()) + ' Cut'
let ring_size = getRingSize()
//let ring_img = Array.from(document.querySelector('div[data-thumbnail-slider]').querySelectorAll('img'))[0].src
let metal_variant_elems = Array.from(document.getElementById('Customize-Metal-Select').querySelectorAll('option'))
let metal_variants = []
let diamond_type = 0


metal_variant_elems.forEach(option=>{
    let name = option.innerText.trim()
    metal_variants.push({'id': option.value,'name':name})
})

//let base_url = 'http://127.0.0.1:9292'
//let base_url = 'https://lucce-development-store.myshopify.com'
let base_url = 'https://luccerings.com'

function getRingSizeAdjustmentVariantId(price){
    const variants = {
        2000: 51513192087832,
        4000: 51513192120600,
        6000: 51513192153368,
        8000: 51513192186136,
        10000: 51513192218904,
        12000: 51513192251672,
        14000: 51513192284440,
        16000: 51513192317208
    }

    return variants[Number(price)]
}

let v_setting_id = document.getElementById('Customize-Metal-Select').value

//diamond selected
let selected_info_top = document.getElementById('Customize-Selected-Diamond-Info-Item-Top')
let selected_info_mid = document.getElementById('Customize-Selected-Diamond-Info-Item-Mid')
let selected_info_bot = document.getElementById('Customize-Selected-Diamond-Info-Item-Bot')
let selected_info_img = document.getElementById('Customize-Selected-Diamond-Info-Item-Img')
let selected_info_change = document.getElementById('Customize-Selected-Diamond-Info-Item-Change')

function formatLuccePhpMoney(price) {
    var phpPrice = Number(price);
    var displayPrice = window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.formatPhpPrice === 'function'
        ? window.LucceCurrencyFormatter.formatPhpPrice(phpPrice)
        : '\u20b1' + phpPrice.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return '<span data-lucce-convert data-lucce-php-price="' + phpPrice + '">' + displayPrice + '</span>';
}

function refreshLucceCustomCurrency() {
    if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.refresh === 'function') {
        window.LucceCurrencyFormatter.refresh();
    }
}

function lucceEscapeAttribute(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function getLucceRingReference() {
    const storageKey = 'lucce:ring-reference:' + ring_handle;
    let referenceToken = sessionStorage.getItem(storageKey);

    if (!referenceToken) {
        referenceToken = (Date.now().toString(36) + Math.random().toString(36).slice(2, 7)).toUpperCase();
        sessionStorage.setItem(storageKey, referenceToken);
    }

    return ring_name + ' — Item ' + referenceToken;
}

function clearLucceRingReference() {
    sessionStorage.removeItem('lucce:ring-reference:' + ring_handle);
}



let url = new URL(location.href)
let metal_param = url.searchParams.get('metal')

let modify = url.searchParams.get('modify')
let diamond_selected = url.searchParams.get('selected')
if(diamond_selected == 'Y'){

    document.getElementById('Customize-Center-Diamond-Choose').style.display = 'none'

    //if diamond selected, set engravings before total btn
    // removed this feature for Alex/design change
    //product_form.insertBefore(engravings_wrapper,selection_wrapper)

    price = url.searchParams.get('price')
    let cts = url.searchParams.get('cts')
    let color = url.searchParams.get('color')
    let clarity = url.searchParams.get('clarity')
    let lab = url.searchParams.get('lab')
    let lab_n = url.searchParams.get('lab_numb')
    let img = url.searchParams.get('img')
    let id = url.searchParams.get('id')
    // let diamond_id = url.searchParams.get('diamond_id')
    let engravings = url.searchParams.get('engravings')
    let diamond_type = url.searchParams.get('diamond_type')

    
    //set options - ring metal, ring size, engraving
    let prev_selected_metal = url.searchParams.get('metal')
    let prev_selected_size = url.searchParams.get('size')
    let prev_selected_engravings = url.searchParams.get('engravings')
    if (engravings_ele && !engravings_ele.disabled) {
        engravings_ele.value = decodeURIComponent(prev_selected_engravings)
    }

    setMetal(prev_selected_metal)
    setRingSize(prev_selected_size)
    setTimeout(()=>{
        setOldMetalSelect()
    },500)
    

    let diamond_type_lbl = 'Lab Grown'

    if(diamond_type == '1'){
        diamond_type_lbl = 'Natural'
    }

    selected_info_img.src = img

    selected_info_top.innerText =  shape + ' ' + cts + 'ct ' + diamond_type_lbl + ' Diamond, ' + color +', ' + clarity + lucceDiamondGradingSummary(url.searchParams, '') + lucceFluorescenceSummary(url.searchParams.get('fluorescent'))
    selected_info_mid.innerText = lab + ' Certificate: ' + lab_n
    selected_info_bot.innerHTML = formatLuccePhpMoney(price)

    engravingsUpdatePriceListener()
    updateTotalPrice(price)
    refreshLucceCustomCurrency()
    //scrollToTitle()
    document.getElementById('Customize-Selected-Diamond-Container').style.display = 'flex'
    document.getElementById('Customize-Diamond-Label').style.display = 'block'

    //change diamond btn
    selected_info_change.addEventListener('click',()=>{
        let ring_img = getRingImg()
        let metal = getMetal()
        let ring_size = getRingSize()
        location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                            '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + encodeURIComponent(getRingEngravingValue()) + '&natural=' + diamond_type
    })

    
    make_selection_btn.classList.add('customize-total-cart-btn')
    

    //Add items to cart
    make_selection_btn.addEventListener('click',async ()=>{
        let engraving_bool = checkEngravings()
        let box_engraving_bool = checkBoxEngravings() //added for Alex
        let pass_check = checkRingSize()
        if(pass_check){

            let height = make_selection_btn.getBoundingClientRect().height
            let btn_original_text = make_selection_btn.innerHTML
            //Set loader
            make_selection_btn.innerHTML =`<div style="visibility:visible;">
            <div class="buy-customize-loader" title="1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
            </div>
            </div>`
            make_selection_btn.style.textAlign = 'center'
            make_selection_btn.style.color = '#fff'
            make_selection_btn.style.height = height + 'px'

            //send diamond id, lab number to lucce api
            let data = {
                id:id,
                earrings:'N',
                engravings: 'N',
                engravings_msg: '',
                box_engravings:'N', //added for Alex
                box_engravings_msg: '', //added for Alex
                code:'1c3f96c0981de4b7f2fd4f505bd4d1493b4660c07203f786b5f133ddc9fa53eb0f6c551b',
            }
        
            fetch(web_server +'/create_diamond',
                    {method: 'POST',body: JSON.stringify(data)}
                    )
            .then(resp=>resp.json())
            .then(data=>{
                
                v_setting_id = document.getElementById('Customize-Metal-Select').value
                if(is_necklace){
                    v_setting_size = '0'
                }else{
                    v_setting_size = document.getElementById('Customize-Size-Select').value
                }

                if (!v_setting_id || !data['diamond_id']) {
                    throw new Error('Missing generated cart variant id')
                }

                
                //added for Alex
                // Build ONE form to add ALL items at once
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = '/cart/add';

                let inputs = '';
                let idx = 0;
                const ringEngravingText = lucceEscapeAttribute(getRingEngravingValue());
                const boxEngravingText = lucceEscapeAttribute(getBoxEngravingValue());
                const birthstoneText = lucceEscapeAttribute(
                    (document.getElementById('birthstone-section') && Array.isArray(window.LucceSelectedBirthstones) ? window.LucceSelectedBirthstones : [])
                        .filter(Boolean)
                        .join(', ')
                );
                const sizeSelect = document.getElementById('Customize-Size-Select');
                const selectedSizeOption = sizeSelect ? sizeSelect.options[sizeSelect.selectedIndex] : null;
                const ringSizePrice = selectedSizeOption ? Number(selectedSizeOption.dataset.sizePrice || 0) : 0;
                const ringSizeVariantId = getRingSizeAdjustmentVariantId(ringSizePrice);
                const ringSizeReference = lucceEscapeAttribute(
                    selectedSizeOption && selectedSizeOption.value === '1'
                        ? 'Select later'
                        : (selectedSizeOption ? selectedSizeOption.value : v_setting_size || '')
                );
                const linkedRingSizeInput = () => ringSizeReference && ringSizeReference !== '0'
                    ? `<input type="hidden" name="items[${idx}][properties][Ring Size]" value="${ringSizeReference}">`
                    : '';
                const ringReference = lucceEscapeAttribute(getLucceRingReference());

                // 0 — Ring with Ring Size property
                inputs += `
                <input type="hidden" name="items[${idx}][id]" value="${v_setting_id}">
                <input type="hidden" name="items[${idx}][quantity]" value="1">
                <input type="hidden" name="items[${idx}][properties][Ring Size]" value="${v_setting_size}">
                <input type="hidden" name="items[${idx}][properties][Ring Reference]" value="${ringReference}">
                ${ringEngravingText ? `<input type="hidden" name="items[${idx}][properties][Ring Engraving]" value="${ringEngravingText}">` : ''}
                ${boxEngravingText ? `<input type="hidden" name="items[${idx}][properties][Box Engraving]" value="${boxEngravingText}">` : ''}
                ${birthstoneText ? `<input type="hidden" name="items[${idx}][properties][Birthstone Inlay]" value="${birthstoneText}">` : ''}
                `;
                idx++;

                if (ringSizePrice > 0 && ringSizeVariantId) {
                inputs += `
                    <input type="hidden" name="items[${idx}][id]" value="${ringSizeVariantId}">
                    <input type="hidden" name="items[${idx}][quantity]" value="1">
                    <input type="hidden" name="items[${idx}][properties][For]" value="${ring_name}">
                    <input type="hidden" name="items[${idx}][properties][Ring Size]" value="${v_setting_size}">
                    <input type="hidden" name="items[${idx}][properties][Ring Reference]" value="${ringReference}">
                `;
                idx++;
                }

                // 1 — Diamond
                inputs += `
                <input type="hidden" name="items[${idx}][id]" value="${data['diamond_id']}">
                <input type="hidden" name="items[${idx}][quantity]" value="1">
                <input type="hidden" name="items[${idx}][properties][Component]" value="Center Diamond">
                <input type="hidden" name="items[${idx}][properties][For]" value="${ring_name}">
                ${linkedRingSizeInput()}
                <input type="hidden" name="items[${idx}][properties][Ring Reference]" value="${ringReference}">
                `;
                idx++;

                form.innerHTML = inputs;
                document.body.appendChild(form);
                clearLucceRingReference();
                form.submit();

                //removed this code 
                // if(engraving_bool == 'Y'){  
                //     //location.href = '/cart/clear?return_to=/cart/update?updates['+ data['engraving_id'] +']=1%26updates['+ data['diamond_id'] +']=1%26updates['+ v_setting_id +']=1'
                //     location.href = '/cart/'+ data['engraving_id'] + ':1,' + data['diamond_id'] + ':1,' + v_setting_id + ':1' + existing_citems + '?attributes[size]=' + v_setting_size + '&storefront=true'
                // } else {
                //     //location.href = '/cart/clear?return_to=/cart/update?updates['+ data['diamond_id'] +']=1%26updates['+ v_setting_id +']=1&note=size:6'
                //     location.href = '/cart/'+ data['diamond_id'] + ':1,' + v_setting_id + ':1' + data['existing_items'] + '?attributes[size]=' + v_setting_size + '&storefront=true'
                // }
            
            })
            .catch(err=>{
                console.log(err)
                make_selection_btn.innerHTML = 'Error'
        
                setTimeout(()=>{
                make_selection_btn.innerHTML = btn_original_text
                },1000)
            })


 
        }
        
    })


    
}
else if(modify == 'Y'){
        //set options - ring metal, ring size, engraving
    let prev_selected_metal = url.searchParams.get('metal')
    let prev_selected_size = url.searchParams.get('size')
    let prev_selected_engravings = url.searchParams.get('engravings')
    if (engravings_ele && !engravings_ele.disabled) {
        engravings_ele.value = decodeURIComponent(prev_selected_engravings)
    }

    setMetal(prev_selected_metal)
    setRingSize(prev_selected_size)
    setTimeout(()=>{
        setOldMetalSelect()
    },500)
    

    setSelectionLink()
    //scrollToTitle()
} else{
    setSelectionLink()
}










function setSelectionLink(){
    if(make_selection_btn){
      
        make_selection_btn.addEventListener('click',()=>{
            let ring_img = getRingImg()
            let height = make_selection_btn.getBoundingClientRect().height
            make_selection_btn.innerHTML =`<div style="visibility:visible;">
                <div class="buy-customize-loader" title="1">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
                </div>
            </div>`
        make_selection_btn.style.textAlign = 'center'
        make_selection_btn.style.height = height + 'px'
            let metal = getMetal()
            let ring_size = getRingSize()
            setTimeout(()=>{
                location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + encodeURIComponent(getRingEngravingValue()) + '&natural=' + diamond_type
            },500)

        })
    }
}


function updateTotalPrice(diamond){
    let total = document.getElementById('Customize-Total-Price-Wrapper')
    total.style.display = 'block'
    let select = document.getElementById('Customize-Metal-Select')
    let price = Number(select.options[select.selectedIndex].dataset.price)/100
    let ring_size_price = getRingSizePrice()
    //let ring_setting_price_normal = Number(document.getElementById('Customize-Product-Price').innerText)/100
    let prod_name = 'RING'
    if(is_necklace){
        prod_name = 'NECKLACE'
    }
    make_selection_btn.innerText = "BUILD YOUR FOREVER PIECE"

    let totalPriceText = document.getElementById('Customize-Total-Price-Text')
    totalPriceText.dataset.lucceIncludesRingSize = ring_size_price > 0 ? 'true' : 'false'
    totalPriceText.innerHTML = formatLuccePhpMoney(Number(diamond) + Number(price) + Number(ring_size_price))
    refreshLucceCustomCurrency()
}

function getRingSizePrice(){
    if(is_necklace){
        return 0
    }

    let select = document.getElementById('Customize-Size-Select')
    if(!select || !select.options[select.selectedIndex]){
        return 0
    }

    return Number(select.options[select.selectedIndex].dataset.sizePrice || 0)
}

function getMetal(){
    let metal
    let setting_id = document.getElementById('Customize-Metal-Select').value
    
    metal_variants.forEach(variant=>{
        if(variant['id'] == setting_id){
            metal = variant['name']
        }
    })

    

    return metal
}

function setMetal(metal_name){
    Array.from(document.getElementById('Customize-Metal-Select').querySelectorAll('option')).forEach(option=>{
        if(option.innerText.toLocaleLowerCase().trim() === metal_name.toLocaleLowerCase().trim()){
            option.selected = true
        }
    })

}


function getRingSize(){
    if(is_necklace){
        return null
    }

    let val = Number(document.getElementById('Customize-Size-Select').value)
    
    if(val !== 0 && val !== 1){
        return val
    } 

    return null
}


function setRingSize(ring_size) {
  if (!ring_size) return;

  const select = document.getElementById('Customize-Size-Select');
  if (!select) return;

  Array.from(select.options).forEach(opt => {
    if (opt.value === String(ring_size)) {
      opt.selected = true;
    }
  });

  // 🔒 force browser state consistency
  select.value = String(ring_size);
}


function checkRingSize(){
    if(is_necklace){
        return true
    }

    let val = Number(document.getElementById('Customize-Size-Select').value)

    if(val !== 0){
        return true
    } 

    document.getElementById('Customize-Product-Error-Text').innerText = "Please select ring size"

    return false
}

if(is_necklace == false){
    let customize_size_select = document.getElementById('Customize-Size-Select')
    customize_size_select .addEventListener('change',()=>{
        if(customize_size_select.value !== '0'){
            document.getElementById('Customize-Product-Error-Text').innerText = ""
        }
    })
}



function scrollToTitle(){
    if(window.innerWidth < 750){
        let title = document.querySelector('.product-single__title')
        if(title){
            // let y = title.getBoundingClientRect().top
            // window.scrollTo(0,y)
            title.scrollIntoView()
        }
    }
}

function getShape(){
    let tags = document.getElementById('Customize-Product-Tags').querySelectorAll('li')
    let shape_found = ''
    tags.forEach(tag=>{
        let tag_txt_uppercase = tag.innerText.toUpperCase()
        shapes.forEach(shape=>{
            if(tag_txt_uppercase.includes(shape)){
                shape_found = shape
            }
        })
    })

    return shape_found
}

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

function engravingsUpdatePriceListener(){
    // Personalization add-ons are excluded from the displayed total.
    // Do not recalculate Total excluding personalization while typing.
}


function checkEngravings(){
    let field = document.getElementById('Customize-Diamond-Engravings')
    let text = getRingEngravingValue()
    if(!field || field.disabled || text == ''){
        return 'N'
    } else {
        return 'Y'
    }
}

//added for Alex
function getRingEngravingValue(){
    let field = document.getElementById('Customize-Diamond-Engravings')
    return field && !field.disabled ? field.value : ''
}

function getBoxEngravingValue(){
    let field = document.getElementById('Customize-Diamond-Box-Engravings')
    return field && !field.disabled ? field.value : ''
}

function checkBoxEngravings(){
    let text = getBoxEngravingValue()
    if(text == ''){
        return 'N'
    } else {
        return 'Y'
    }
}

document.getElementById('Customize-Metal-Select').addEventListener('change',(e)=>{
    setOldMetalSelect()
})

function setOldMetalSelect(){
    // 🔒 Do NOT re-sync variants after diamond is selected
    if (diamond_selected === 'Y') return;

    let old_metal_select = document.querySelector('.single-option-selector-product-template-lab-diamond')
    if (!old_metal_select) return;

    let old_metal_select_options = Array.from(old_metal_select.querySelectorAll('option'))
    let select = document.getElementById('Customize-Metal-Select')
    let selected = select.options[select.selectedIndex].text

    old_metal_select_options.forEach(option=>{
        if(option.innerText.toLowerCase().trim() === selected.toLowerCase().trim()){
           old_metal_select.selectedIndex = option.index
           old_metal_select.dispatchEvent(new Event('change'))
        }
    })
}

if (diamond_selected === 'Y' && !is_necklace) {
    const sizeContainer = document.getElementById('Customize-Size-Select')?.closest('.Customize-Metal-Size-Container');
    if (sizeContainer) {
        sizeContainer.style.display = 'block';
    }
}

function getRingImg(){
    let objs = Array.from(document.querySelectorAll('.product-single__media-wrapper'))
    let img = ''
    objs.forEach(o=>{
        if(o.classList.contains('hide') == false){
            img = getBestRingImageUrl(o.querySelector('img'))
        }
    })

    if(img == '')
    img = Array.from(document.querySelector('div[data-thumbnail-slider]').querySelectorAll('img'))[0].src

    return img
}

function getBestRingImageUrl(image){
    if(!image) return ''

    if(image.srcset){
        let candidates = image.srcset.split(',').map(candidate=>{
            let parts = candidate.trim().split(/\s+/)
            return {
                url: parts[0],
                width: Number((parts[1] || '').replace('w', '')) || 0
            }
        }).filter(candidate=>candidate.url)

        let preferred = candidates.find(candidate=>candidate.width >= 360)
        if(preferred) return preferred.url

        if(candidates.length > 0) return candidates[candidates.length - 1].url
    }

    return image.currentSrc || image.src || ''
}


async function get_previous_items(){
    return $.ajax({
        type:'GET',
        url:'\\cart.js',
       });

}

function parse_previous_items(data){
    data = JSON.parse(data)
    //already in cart
    let existing_products = ''
    let items = data['items']

    
    items.forEach(item=>{
        existing_products = existing_products + ',' + item['variant_id'] + ':' + item['quantity']
    })

    return existing_products
}

//center diamond type
let center_diamond_type = document.getElementById('Customize-Center-Diamond-Type')
let center_diamond_option_lab = document.getElementById('Customize-Center-Diamond-Option-Lab')
let center_diamond_option_natural = document.getElementById('Customize-Center-Diamond-Option-Natural')

center_diamond_option_lab.addEventListener('click',(e)=>{
    center_diamond_type.innerText = 'Lab'
    center_diamond_option_natural.classList.remove('customize-center-diamond-option-natural-active')
    center_diamond_option_lab.classList.add('customize-center-diamond-option-lab-active')
    diamond_type = 0
})

center_diamond_option_natural.addEventListener('click',(e)=>{
    center_diamond_type.innerText = 'Natural'
    center_diamond_option_lab.classList.remove('customize-center-diamond-option-lab-active')
    center_diamond_option_natural.classList.add('customize-center-diamond-option-natural-active')
    diamond_type = 1
})




// add setting price icon
let customize_product_price_ele = document.querySelector('.product__price')
let customize_setting_price_info_icon = document.createElement('span')

customize_setting_price_info_icon.classList.add('customize-setting-price-info-icon-product-page')

customize_setting_price_info_icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>`

let customize_setting_price_info_text = document.createElement('div')
customize_setting_price_info_text.style.display = 'none'
customize_setting_price_info_text.classList.add('customize-setting-price-info-text-product-page')

customize_setting_price_info_text.style.maxWidth = document.getElementById('Customize-Make-Selection').getBoundingClientRect().width + 'px'

customize_setting_price_info_text.innerHTML = `<div>The Setting Price refers to the price of the ring’s metalwork that holds your Center Stone. It includes the ring’s accents, pavé, halo, and side stones. It does not include the price of the Center Stone that you will choose. The Setting Price + Center Stone Price = Total Price.</div>`

customize_setting_price_info_icon.addEventListener('mouseenter',()=>{
    document.getElementById('Customize-Metal-Size-Container').style.opacity = '0.1'
    customize_setting_price_info_text.style.display = 'block'
})
customize_setting_price_info_icon.addEventListener('mouseleave',()=>{
    document.getElementById('Customize-Metal-Size-Container').style.opacity = '1'
    customize_setting_price_info_text.style.display = 'none'
})

customize_product_price_ele.append(customize_setting_price_info_icon)
customize_product_price_ele.append(customize_setting_price_info_text)
